import { Component, Input } from '@angular/core';
import { RelatedStrategies } from '@marketing/insights/insights.interface';
import { TranslateService } from '@shared/translate/translate.service';

@Component({
  selector: 'ft-article-related-strategies',
  templateUrl: './article-related-strategies.component.html',
  styleUrls: ['./article-related-strategies.component.scss'],
})
export class ArticleRelatedStrategiesComponent {
  @Input() relatedStrategies: RelatedStrategies;
  strategyTabContentUnavailable: string;

  constructor(private translateService: TranslateService) {
    this.strategyTabContentUnavailable = this.translateService.instant(
      'common.strategyTabContentUnavailable'
    );
  }
}
